import React from "react";
import { CompanionThreadsProvider } from "../contexts/CompanionThreadsContext";

const withCompanionProviders = <Props extends object>(Component: React.ComponentType<Props>) => {
  const Wrapped = (props: Props) => (
    <CompanionThreadsProvider>
      <Component {...props} />
    </CompanionThreadsProvider>
  );

  const componentName = Component.displayName ?? Component.name ?? "Component";
  Wrapped.displayName = `withCompanionProviders(${componentName})`;

  return Wrapped;
};

export default withCompanionProviders;
